import React from 'react';

type SizeProps = {
  size?: string;
}

/**
 * Double bed seen from above. Deliberately distinct from `BedSmallSvg`, which is a
 * side-on single bed, so a bedroom count and a bed count can sit side by side.
 *
 * Drawn on a 24 grid at stroke 1.5 so its rendered weight matches the 16-grid,
 * stroke-1 icons it sits beside.
 */
export const BedroomSvg: React.FunctionComponent<SizeProps> = ({ size }: SizeProps) => (
  <svg
    width={size || 16}
    height={size || 16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.5"
      y="2.75"
      width="17"
      height="18.5"
      rx="2"
      stroke="#292929"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <rect
      x="5.75"
      y="5.25"
      width="5"
      height="3.5"
      rx="1"
      stroke="#292929"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <rect
      x="13.25"
      y="5.25"
      width="5"
      height="3.5"
      rx="1"
      stroke="#292929"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 11.75H20.5"
      stroke="#292929"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
